import React, { useState } from "react";

const PSIForm = (props) => {
    const [isSeriousIncident, setIsSeriousIncident] = useState(false);
    const [loading, setLoading] = useState(false);
    const [additionalFormLoading, setAdditionalFormLoading] = useState(false);

    const handleSubmit = (formData) => {
        props.onFormSubmit(formData, props.incidentId);
    };

    return (
        <div style={{ maxWidth: 400, margin: "2rem auto", padding: "2rem", border: "1px solid #ccc", borderRadius: 8 }}>
            <h2>OHS Potential Serious Incident</h2>
            <div style={{ margin: "1.5rem 0" }}>
                <label style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
                    <input
                        type="checkbox"
                        checked={isSeriousIncident}
                        onChange={() => setIsSeriousIncident(!isSeriousIncident)}
                        style={{ marginRight: 8 }}
                    />
                    This is a potentially serious incident
                </label>
            </div>
            {isSeriousIncident && (
                <div style={{ background: "#fff3cd", color: "#856404", padding: "1rem", borderRadius: 4, border: "1px solid #ffeeba" }}>
                    <strong>Reminder:</strong> Please report this incident immediately on the <a href="https://www.alberta.ca/report-potentially-serious-incidents" target="_blank" rel="noopener noreferrer">OHS website</a>.
                </div>
            )}
            <button 
                type="submit" 
                disabled={additionalFormLoading}
                className={additionalFormLoading ? 'submit-button disabled' : 'submit-button'}
                onClick={() => handleSubmit({ isSeriousIncident })}
            >
                {additionalFormLoading ? 'Submitting...' : 'Submit'}
            </button>
        </div>
    );
};

export default PSIForm;